<template>
  <!-- 外层容器重构，分离PC/移动端布局控制 -->
  <div class="library-root-container">
    <!-- PC端布局（原结构，屏幕>767px显示） -->
    <div class="pc-layout">
      <div class="pc-inner-container">
        <div class="library-box" style="flex: 1; margin-right: 1.5rem">
          <!-- 新手引导组件 -->
          <Guide
              :steps="guideSteps"
              storage-key="my_app_guide_completed"
              @complete="onGuideComplete"
          />
          <div>
            <span class="scope-title">{{ $t("studentProgramme.category") }}</span>
            <img src="@/assets/images/way.png" width="18px;" @click="onStartGuide">
            <div class="guide1" ref="guide1">
              <div
                  class="scope-text cursor-pointer"
                  :class="scopeIndex == index ? 'active' : ''"
                  v-for="(item, index) in scopeData"
                  :key="index"
                  @click="changeIndex(0, index)"
                  ref="scope-text"
              >
                {{ item }}
              </div>
            </div>
          </div>
          <div class="scope-box" ref="scope-box">
            <span class="scope-title">{{ $t("studentProgramme.topic") }}</span>
            <div v-if="topicData[scopeIndex]">
              <!-- 核心修改：增加强制的样式类和内联样式，确保布局生效 -->
              <div ref="guide2"
                   class="scope-text cursor-pointer guide2"
                   :class="topicIndex == index ? 'active' : ''"
                   v-for="(item, index) in topicData[scopeIndex]"
                   :key="index"
                   @click="changeIndex(1, index, item.id)"
                   style="display: flex; justify-content: space-between; align-items: center; width: 100%; box-sizing: border-box; padding: 0 8px;"
              >
                <!-- 左侧内容 -->
                <span style="flex: 1; text-align: left;">{{ item.number }}&nbsp;&nbsp;{{ item.name }}</span>

                <!-- 右侧星星容器（强制靠右） -->
                <!--              <div style="display: flex; align-items: center; justify-content: flex-end; min-width: 60px;">-->
                <!--                <img style="height: 18px; margin: 0 2px;" :src="item.star > 0 ? require('@/assets/images/star-light.png') : require('@/assets/images/star-dark.png')" />-->
                <!--                <img style="height: 18px; margin: 0 2px;" :src="item.star > 1 ? require('@/assets/images/star-light.png') : require('@/assets/images/star-dark.png')" />-->
                <!--                <img style="height: 18px; margin: 0 2px;" :src="item.star > 2 ? require('@/assets/images/star-light.png') : require('@/assets/images/star-dark.png')" />-->
                <!--              </div>-->
              </div>
            </div>
          </div>
        </div>
        <div class="library-box" style="font-weight: bold; flex: 2.5">
          <div
              v-if="
              topicData[scopeIndex] && practisesList[scopeIndex + '-' + topicIndex]
            "
          >
            <div class="topic-title">
              {{ topicData[scopeIndex][topicIndex].name }}
            </div>
            <div ref="guide3"
                 class="body guide3"
                 v-for="(item, index) in practisesList[scopeIndex + '-' + topicIndex]"
                 :key="index"
            >
              <div>
                <div class="text1">{{ $t("studentProgramme.practice1") }} ({{ index + 1 }})</div>
                <div
                    class="text2"
                    style="white-space: normal;"
                >
                  {{ item.desc || item.number || ' '}}
                </div>
                <div type="text">
                  <template>
                    <img style="height: 18px;" v-if="item.star == 0" :src="require('@/assets/images/s0.png')" />
                    <img style="height: 18px;" v-if="item.star == 1" :src="require('@/assets/images/s1.png')" />
                    <img style="height: 18px;" v-if="item.star == 2" :src="require('@/assets/images/s2.png')" />
                    <img style="height: 18px;" v-if="item.star == 3" :src="require('@/assets/images/s3.png')" />
                  </template>
                </div>
              </div>
              <div style="white-space: nowrap">
                <button class="cursor-pointer" @click="showTeaching(item)">
                  {{ $t("studentProgramme.watchTeaching") }}
                </button>
                <button
                    class="cursor-pointer"
                    @click="goExamination(item)"
                >
                  {{ $t("studentProgramme.goPractice") }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 手机端布局（新增，屏幕≤767px显示） -->
    <div class="mobile-layout">
      <div class="mobile-inner-container">
        <!-- 新手引导组件（手机端专用） -->
        <Guide
            :steps="mobileGuideSteps"
            storage-key="my_app_guide_completed"
            @complete="onGuideComplete"
        />

        <!-- 范畴列表（手机端卡片式） -->
        <div class="mobile-card mobile-guide1" ref="mobileGuide1">
          <div class="mobile-card-header">
            <span class="scope-title">{{ $t("studentProgramme.category") }}</span>
            <img src="@/assets/images/way.png" width="18px;" @click="onStartGuide" class="guide-icon">
          </div>
          <div class="mobile-grid-list">
            <div
                class="mobile-grid-item cursor-pointer"
                :class="scopeIndex == index ? 'active' : ''"
                v-for="(item, index) in scopeData"
                :key="index"
                @click="changeIndex(0, index)"
            >
              {{ item }}
            </div>
          </div>
        </div>

        <!-- 课题列表（手机端卡片式） -->
        <div class="mobile-card mobile-guide2" ref="mobileGuide2" v-if="topicData[scopeIndex]">
          <div class="mobile-card-header">
            <span class="scope-title">{{ $t("studentProgramme.topic") }}</span>
          </div>
          <div class="mobile-grid-list">
            <div
                class="mobile-grid-item cursor-pointer"
                :class="topicIndex == index ? 'active' : ''"
                v-for="(item, index) in topicData[scopeIndex]"
                :key="index"
                @click="changeIndex(1, index, item.id)"
            >
              {{ item.number }}&nbsp;&nbsp;{{ item.name }}
              <!--              <div>-->
              <!--                <img style="height: 14px; margin: 0 2px;" :src="item.star > 0 ? require('@/assets/images/star-light.png') : require('@/assets/images/star-dark.png')" />-->
              <!--                <img style="height: 14px; margin: 0 2px;" :src="item.star > 1 ? require('@/assets/images/star-light.png') : require('@/assets/images/star-dark.png')" />-->
              <!--                <img style="height: 14px; margin: 0 2px;" :src="item.star > 2 ? require('@/assets/images/star-light.png') : require('@/assets/images/star-dark.png')" />-->
              <!--              </div>-->
            </div>
          </div>
        </div>

        <!-- 练习内容区域（手机端卡片式） -->
        <div class="mobile-card" v-if="topicData[scopeIndex] && practisesList[scopeIndex + '-' + topicIndex]">
          <div class="mobile-topic-title">
            {{ topicData[scopeIndex][topicIndex].name }}
          </div>
          <div class="mobile-practice-list mobile-guide3" ref="mobileGuide3">
            <div
                class="mobile-practice-card"
                v-for="(item, index) in practisesList[scopeIndex + '-' + topicIndex]"
                :key="index"
            >
              <div class="practice-content">
                <div class="text1">{{ $t("studentProgramme.practice1") }} ({{ index + 1 }})</div>
                <div class="text2" style="white-space: normal;">
                  {{ item.desc || item.number || ' '}}
                </div>
                <div type="text">
                  <template>
                    <img style="height: 18px;" v-if="item.star == 0" :src="require('@/assets/images/s0.png')" />
                    <img style="height: 18px;" v-if="item.star == 1" :src="require('@/assets/images/s1.png')" />
                    <img style="height: 18px;" v-if="item.star == 2" :src="require('@/assets/images/s2.png')" />
                    <img style="height: 18px;" v-if="item.star == 3" :src="require('@/assets/images/s3.png')" />
                  </template>
                </div>
              </div>
              <div class="practice-actions">
                <button class="action-btn teach-btn" @click="showTeaching(item)">
                  {{ $t("studentProgramme.watchTeaching") }}
                </button>
                <button class="action-btn practice-btn" @click="goExamination(item)">
                  {{ $t("studentProgramme.goPractice") }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 弹窗组件（共用） -->
    <PracticepreDialog
        v-if="teachingSwitch"
        :showDate="showDate"
        @closeDialog="teachingSwitch = false"
    ></PracticepreDialog>
  </div>
</template>

<script>
import { scope } from "@/biz/static-data";
import { getTopics, getTopicsDetail } from "@/api/topic";
import PracticepreDialog from "@/components/Teaching/practicepreDialog.vue";
import moment from 'moment'
import Guide from '@/components/guide/Guide.vue'
import {getUserInfo} from "@/utils/auth";
export default {
  components: {
    PracticepreDialog,
    Guide
  },
  props: {
    detail: {
      type: Object,
      default: function () {},
    },
  },
  data() {
    return {
      gradeId: null,
      scopeData: [],
      topicData: {},
      practisesList: {},
      scopeIndex: 0,
      topicIndex: 0,
      teachingSwitch: false,
      showDate: null,
      storageKey: 'user_guide_completed',
      // PC端引导步骤（保留）
      guideSteps: [
        {
          target: '.guide1',
          text: this.$t('studentProgramme.guide1'),
          position: 'bottom'
        },
        {
          target: '.guide2',
          text: this.$t('studentProgramme.guide2'),
          position: 'bottom'
        },
        {
          target: '.guide3',
          text: this.$t('studentProgramme.guide3'),
          position: 'bottom'
        }
      ],
      // 手机端引导步骤（新增）
      mobileGuideSteps: [
        {
          target: '.mobile-guide1',
          text: this.$t('studentProgramme.guide1'),
          position: 'bottom'
        },
        {
          target: '.mobile-guide2',
          text: this.$t('studentProgramme.guide2'),
          position: 'bottom'
        },
        {
          target: '.mobile-guide3',
          text: this.$t('studentProgramme.guide3'),
          position: 'bottom'
        }
      ]
    };
  },
  watch: {
    "$store.getters.language": {
      handler(v) {
        this.$nextTick(() => {
          this.scopeData = scope[v];
        });
        this.$forceUpdate();
      },
      deep: true,
      immediate: true,
    },
    "$store.getters.currentGradeId": {
      handler(v) {
        this.gradeId = v;
        this.topicData = {};
        this.practisesList = {};
        this.scopeIndex = 0;
        this.topicIndex = 0;
        this.getTopics(0);
        this.$forceUpdate();
      },
      deep: true,
      immediate: true,
    },
  },
  mounted() {
    this.gradeId = this.$store.getters.currentGradeId;
    this.scopeData = scope[this.$store.getters.language];
    this.getTopics(0);
  },
  methods: {
    onStartGuide() {
      localStorage.setItem(this.storageKey, 'false');
      location.reload(); // 刷新当前页面
    },
    onGuideComplete() {
      localStorage.setItem(this.storageKey, 'true'); // 存储字符串 'true'
    },
    // 进入答题页
    goExamination(item) {
      window.sessionStorage.curGradeId = this.gradeId;
      window.sessionStorage.curScopeId = this.scopeIndex;
      window.sessionStorage.triviaQuiz = "false"
      this.$router.push({
        path: '/examination',
        query: {
          type: 'library',
          topicId: this.topicData[this.scopeIndex][this.topicIndex]?.id || '',
          id: item.id,
          gradeId: this.gradeId,
          startTime: moment().format('YYYY-MM-DD HH:mm:ss')
        },
      })
    },
    changeIndex(i, index, id) {
      if (i == 0) {
        this.scopeIndex = index;
        this.topicIndex = 0;
        this.getTopics(index);
      } else {
        this.topicIndex = index;
        this.getTopicsDetail(index, id);
      }
    },
    getTopics(index) {
      if (!this.topicData[index] && this.gradeId) {
        let form = {
          studentId: this.detail.id || '',
          gradeId: this.gradeId,
          scope: this.scopeIndex,
          _page: 0,
          _limit: 3000,
          lang: getUserInfo("userProfile")?.studying || 0,
        };
        getTopics(form).then((v) => {
          if (v.data.length > 0) {
            this.topicData[index] = v.data.sort((a, b) => {
              return a.number - b.number;
            });
            this.getTopicsDetail(0, this.topicData[index][0]?.id);
          }
          this.$nextTick(() => {
            this.$forceUpdate();
          });
        }).catch(err => {
          console.error('获取课题列表失败:', err);
        });
      }
    },
    getTopicsDetail(index, id) {
      if (!id) return;
      let key = this.scopeIndex + "-" + index;
      if (!this.practisesList[key]) {
        getTopicsDetail(id).then((v) => {
          this.practisesList[key] = v.data.practises.sort((a, b) => {
            return a.number - b.number;
          });
          this.$nextTick(() => {
            this.$forceUpdate();
          });
        }).catch(err => {
          console.error('获取练习列表失败:', err);
        });
      }
    },
    showTeaching(item) {
      this.teachingSwitch = true;
      this.showDate = { practise: item };
      this.showDate.topicsId = this.topicData[this.scopeIndex][this.topicIndex]?.id || '';
    },
  },
};
</script>

<style lang="scss" scoped>
// 定义响应式断点
$phoneMaxWidth: 767px;
$tabletMinWidth: 768px;
$tabletMaxWidth: 1024px;
$desktopMinWidth: 1025px;

// 根容器
.library-root-container {
  width: 100%;
  min-height: 100vh;
  box-sizing: border-box;
}

// ---------------- PC端样式（保留原有逻辑，仅调整容器） ----------------
.pc-layout {
  display: block;
  width: 100%;

  .pc-inner-container {
    display: flex;
    padding: 7.375rem 2.5vw 1.5rem;
    overflow-x: hidden;
  }

  .library-box {
    border-radius: 2.5rem;
    background: #ffffff;
    padding: 2rem;//3rem;
    font-size: 1.25rem;//1.5rem;
    height: 100%;

    .scope-box {
      margin-top: 2rem;//3rem;
    }

    .scope-title {
      font-size: 1.5rem;//2rem;
      color: #b62d2e;
      font-weight: bold;
      word-break: normal;
      overflow-wrap: break-word;
    }

    .scope-title-2 {
      font-size: 1rem;//2rem;
      color: #000000;
      font-weight: bold;
      word-break: normal;
      overflow-wrap: break-word;
    }

    .topic-title {
      font-size: 2.25rem;//3rem;
      font-weight: bold;
      color: #b62d2e;
      text-align: center;
      margin-bottom: 2rem;//3rem;
      word-break: normal;
      overflow-wrap: break-word;
    }

    .body {
      display: flex;
      justify-content: space-between;
      background: #fef7ee;
      border-radius: 1.25rem;
      padding: 1.75rem;//2.5rem;
      margin-top: 1rem;
      align-items: center;
    }

    .scope-text {
      line-height: 1.5;
      background: #f9d8b1;
      border: 0.15rem #f1aa55 solid;
      border-radius: 0.75rem;
      padding: 0.25rem;
      margin: 0.25rem 0;
      word-break: normal;
      overflow-wrap: break-word;
    }

    .scope-text.active {
      background: #d07d11;
      border: 0.15rem #f3b768 solid;
      font-weight: bold;
    }

    .text1 {
      color: #8e8e8e;
      line-height: 1.4;
    }

    .text2 {
      color: #b62d2e;
      font-size: 1.5rem;//2rem;
      line-height: 1.4;
      word-break: normal;
      overflow-wrap: break-word;
    }

    button {
      background: #fcc03a;
      box-shadow: 0px 0.5rem 0 #c28c00;
      border: none;
      border-radius: 2.75rem;
      padding: 0.875rem 1.75rem;
      font-size: 1.5rem;//2rem;
      font-weight: bold;
      word-break: normal;
      overflow-wrap: break-word;

      & + button {
        margin-left: 0.75rem;//1rem;
      }
    }
  }

  // PC端平板适配（保留）
  @media (min-width: $tabletMinWidth) and (max-width: $tabletMaxWidth) {
    .library-box {
      padding: 1.75rem;
      font-size: 1.125rem;

      .scope-box {
        margin-top: 0.75rem;
      }

      .scope-title {
        font-size: 1.375rem;
      }

      .topic-title {
        font-size: 2rem;
        margin-bottom: 1.75rem;
      }

      .body {
        padding: 1.5rem;
      }

      button {
        padding: 0.75rem 1.5rem;
        font-size: 1.375rem;

        & + button {
          margin-left: 0.625rem;
        }
      }

      .text2 {
        font-size: 1.375rem;
      }
    }
  }
}

// ---------------- 手机端样式（新增核心） ----------------
.mobile-layout {
  display: none;
  width: 100%;
  padding: 12rem 5vw 1.5rem;
  box-sizing: border-box;
  min-height: 100vh;

  .mobile-inner-container {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
  }

  // 顶部操作栏
  .mobile-top-bar {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .mobile-title-group {
      display: flex;
      align-items: center;
      gap: 0.5rem;

      .guide-icon {
        cursor: pointer;
      }
    }
  }

  // 通用卡片样式
  .mobile-card {
    background: #ffffff;
    border-radius: 1.25rem;
    box-shadow: 0 0.25rem 1rem rgba(0, 0, 0, 0.08);
    padding: 1.5rem;
    width: 100%;
    box-sizing: border-box;

    .mobile-card-header {
      margin-bottom: 1rem;
    }
  }

  // 网格列表（范畴/课题）
  .mobile-grid-list {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));
    gap: 0.75rem;
    width: 100%;

    .mobile-grid-item {
      background: #f9d8b1;
      border: 2px solid #f1aa55;
      border-radius: 0.75rem;
      padding: 0.75rem 0.5rem;
      text-align: center;
      font-size: 0.9rem;
      transition: all 0.3s ease;
      word-break: normal;
      overflow-wrap: break-word;

      &.active {
        background: #d07d11;
        border-color: #f3b768;
        color: white;
        font-weight: bold;
        transform: translateY(-2px);
        box-shadow: 0 0.25rem 0.5rem rgba(208, 125, 17, 0.2);
      }

      &:hover {
        transform: translateY(-2px);
      }
    }
  }

  // 课题标题
  .mobile-topic-title {
    font-size: 1.5rem;
    font-weight: bold;
    color: #b62d2e;
    text-align: center;
    margin-bottom: 1.5rem;
    padding-bottom: 1rem;
    border-bottom: 2px solid #f9d8b1;
    word-break: normal;
    overflow-wrap: break-word;
  }

  // 练习列表
  .mobile-practice-list {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    width: 100%;
  }

  // 练习卡片
  .mobile-practice-card {
    background: #fef7ee;
    border-radius: 1rem;
    padding: 1.25rem;
    box-shadow: 0 0.25rem 0.75rem rgba(0, 0, 0, 0.05);
    transition: all 0.3s ease;

    &:hover {
      transform: translateY(-3px);
      box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.08);
    }

    .practice-content {
      margin-bottom: 1rem;

      .text1 {
        color: #8e8e8e;
        font-size: 0.875rem;
        margin-bottom: 0.5rem;
      }

      .text2 {
        color: #b62d2e;
        font-size: 1rem;
        line-height: 1.5;
        word-break: normal;
        overflow-wrap: break-word;
      }
    }

    .practice-actions {
      display: flex;
      gap: 0.75rem;
      justify-content: center;
      flex-wrap: wrap;
      width: 100%;
    }

    .action-btn {
      flex: 1;
      min-width: 120px;
      background: #fcc03a;
      box-shadow: 0 0.25rem 0 #c28c00;
      border: none;
      border-radius: 2rem;
      padding: 0.75rem 1rem;
      font-size: 0.875rem;
      font-weight: bold;
      color: #333;
      cursor: pointer;
      transition: all 0.2s ease;
      word-break: normal;
      overflow-wrap: break-word;

      &:active {
        transform: translateY(2px);
        box-shadow: none;
      }

      &.practice-btn {
        background: #b62d2e;
        box-shadow: 0 0.25rem 0 #8a1e1f;
        color: white;
      }
    }
  }

  // 手机端文本样式统一
  .scope-title {
    font-size: 1.125rem;
    color: #b62d2e;
    font-weight: bold;
    word-break: normal;
    overflow-wrap: break-word;
  }
}

// ---------------- 响应式切换核心 ----------------
// 手机端显示
@media (max-width: $phoneMaxWidth) {
  .pc-layout {
    display: none !important;
  }

  .mobile-layout {
    display: block !important;
  }
}

// PC/平板端显示
@media (min-width: $tabletMinWidth) {
  .pc-layout {
    display: block !important;
  }

  .mobile-layout {
    display: none !important;
  }
}

// 原有手机端样式兼容（废弃，保留仅做兼容）
@media (min-width: 320px) and (max-width: $phoneMaxWidth) {
  .pc-layout .library-box {
    padding: 1.375rem;
    font-size: 0.875rem;

    .scope-box {
      margin-top: 1.375rem;
    }

    .scope-title {
      font-size: 1.125rem;
    }

    .topic-title {
      font-size: 1.75rem;
      margin-bottom: 1.375rem;
    }

    .body {
      padding: 1.125rem;
    }

    button {
      padding: 0.625rem 1.25rem;
      font-size: 1.125rem;

      & + button {
        margin-left: 0.5rem;
      }
    }

    .text2 {
      font-size: 1.125rem;
    }
  }
}
</style>